import WithoutDriver from "components/shared/withoutDriver";
import { dateTimeToView } from "helpers/date";
import {
    getServiceWorkAddresses,
    getServiceWorkResponsible,
    getServiceWorkType,
    ServiceWorkStatusRow,
} from "helpers/serviceWorks";
import React from "react";
import { Scrollbars } from "react-custom-scrollbars-2";

export const ServiceWorkTooltipContent = ({ serviceWork }) => {
    const {
        carNumber,
        trailerNumber,
        createdAt,
        withoutCargo,
        serviceTime,
        startDate,
        endDate,
        comment,
        emptyMileageBid,
    } = serviceWork;
    const addresses = getServiceWorkAddresses(serviceWork);

    return (
        <div>
            {emptyMileageBid && <span className="badge badge-brand mb-1">Порожняя заявка</span>}
            <ServiceWorkStatusRow serviceWork={serviceWork} />
            {withoutCargo && (
                <div>
                    <strong className="pr-2 text-danger">Требования:</strong>
                    <strong className="text-danger">Без груза</strong>
                </div>
            )}
            <div>
                <strong className="pr-2">Тип сервисной работы:</strong>
                <span>{getServiceWorkType(serviceWork)}</span>
            </div>
            {carNumber && (
                <div>
                    <strong className="pr-2">Госномер грузовика:</strong>
                    <span>{carNumber}</span>
                </div>
            )}
            {trailerNumber && (
                <div>
                    <strong className="pr-2">Госномер прицепа:</strong>
                    <span>{trailerNumber}</span>
                </div>
            )}
            <div>
                <strong className="pr-2">Ответственный:</strong>
                <span>{getServiceWorkResponsible(serviceWork)}</span>
            </div>
            {createdAt && (
                <div>
                    <strong className="pr-2">Дата постановки:</strong>
                    <span>{dateTimeToView(createdAt, "DD.MM.YYYY HH:mm (Z)")}</span>
                </div>
            )}
            <div>
                <strong className="pr-2">Период работ:</strong>
                <span>
                    {dateTimeToView(startDate, "DD.MM.YYYY HH:mm (Z)")} -{" "}
                    {dateTimeToView(endDate, "DD.MM.YYYY HH:mm (Z)")}
                </span>
            </div>
            {serviceTime && (
                <div>
                    <strong className="pr-2">Время выполнения сервисных работ:</strong>
                    <span>{serviceTime}</span>
                </div>
            )}
            {comment && (
                <div>
                    <strong className="pr-2">Комментарий:</strong>
                    <span>
                        <WithoutDriver title={comment} />
                    </span>
                </div>
            )}
            <div>
                <div className="font-weight-bold">Плановые СТО:</div>
                <ul className="mb-0">
                    {addresses.map((address, index) => (
                        <li key={index}>{address}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export const ServiceWorksTooltipContent = ({ serviceWorks = [] }) => (
    <Scrollbars autoHeight autoHeightMin={100} autoHeightMax={700} style={{ width: 400 }}>
        {serviceWorks.map((serviceWork, index) => (
            <div key={serviceWork.id ?? serviceWork.serviceWorkId ?? index} className={index === serviceWorks.length - 1 ? "" : "pb-3"}>
                <ServiceWorkTooltipContent serviceWork={serviceWork} />
            </div>
        ))}
    </Scrollbars>
);
